/**
 * Created by pmnia on 07/05/15.
 */

(function (app) {

    "use strict";

    app.factory('ObtBaseFactory',ObtBaseFactory);
    app.service("obtBaseService", obtBaseService);

    /*@ngInject*/
    function obtBaseService (queryservice ) {
        return {
            getItems : getItems,
            updateItem : updateItem,
            addItem : addItem,
            deleteItem:deleteItem
        };

        function callServer(args, functionName){
            queryservice.setEvnArgs(args);
            return queryservice.callServer(functionName, args, null);
        }
        function getItems(args){
            args = args || {};
            args.format=1;
            return callServer(args, "obtStatementsHelper.getAccountSummary");
        }
        function addItem (data){
            return callServer(data, "obtStatementsHelper.add");
        }
        function updateItem (data){
            return callServer(data, "obtStatementsHelper.update");
        }
        function deleteItem (key){
            var args = {tId:key};
            return callServer(args, "obtStatementsHelper.delete");
        }
    }
    /*@ngInject*/
    function ObtBaseFactory(obtBaseService, $log){
        var factory = function(args, data, service){
            this.infos = data || null;
            this.args = args || {};
            this.service = service || obtBaseService || null;

            this.infosField = null;
            this.infosDetailsField = null;  //Disabled if null
            this.errorField = 'error';
            this.errorMsgField = 'body';
        };

        factory.prototype.setData = setData;
        factory.prototype.setArgs =setArgs;
        factory.prototype.getArgs = getArgs;
        factory.prototype.getArg = getArg;
        factory.prototype.getData = getData;
        factory.prototype.updateItem = updateItem;
        factory.prototype.deleteItem = deleteItem;
        factory.prototype.addItem = addItem;
        factory.prototype.reload =reload;
        factory.prototype.isError = isError;
        factory.prototype.getError = getError;
        factory.prototype.isErrorInResponse = isErrorInResponse;
        factory.prototype.transformData = transformData;
        return factory;

        function setData(data){
            //data[0].seoKeywords = [];
            this.infos = this.transformData(data);

        }
        function setArgs(args){
            this.args = args;
        }
        function getArgs(){
            return this.args ? this.args : {};
        }
        function getArg(name){
            return this.args && this.args[name] ? this.args[name] : null;
        }
        function getData(){
            if(this.isError()){
                return null;
            }
            return this.infos && this.infosField ? this.infos[this.infosField] : this.infos;
        }

        function reload(){
            console.log('reload called');
            if(this.service){
                var factoryInstance = this;
                return this.service.getItems(this.getArgs()).then(
                    function (response) {
                        factoryInstance.setData(response);
                        console.log('model reloaded');
                    });
            }}

        function addItem(item){
            $log.debug('add item');
            var factoryInstance = this;
            return this.service.addItem(item)
                .then(function (response) {
                    console.log('add done');
                    return response;
                }).finally(function (){
                    return factoryInstance.reload();
                });
        }

        function updateItem(item, stopReloadIfError){
            stopReloadIfError = stopReloadIfError ? true : false;

            $log.debug('update item');
            var factoryInstance = this;
            return this.service.updateItem(item || this.infos)
                .then(function (response) {
                    console.log('update done');
                    if(stopReloadIfError){
                        stopReloadIfError = factoryInstance.isErrorInResponse(response);
                    }
                    return response;
                }).finally(function (){
                    if(!stopReloadIfError){
                        return factoryInstance.reload();
                    }
                });
        }

        function deleteItem(itemId){
            $log.debug('delete item');
            var factoryInstance = this;
            return this.service.deleteItem(itemId)
                .then(function (response) {
                    console.log('delete done');
                    return response;
                }).finally(function (){
                    return factoryInstance.reload();
                });
        }

        function isErrorInResponse(response){
            return response && response.error && response.error == 1;
        }
        function isError(){
            return this.infos && this.infos[this.errorField] == 1 ? true : false ;
        }
        function getError(){
            return this.infos && this.isError() ? this.infos[this.errorMsgField] : "";
        }
        function transformData(data){
            angular.forEach(data.rows, function(item){
                if(item.fTime){
                    item.fTime = moment(item.fTime);
                }
                if(item.lTime){
                    item.lTime = moment(item.lTime);
                }
                if(item.tTime){
                    item.tTime = moment(item.tTime);
                }
                if(item.opDate){
                    item.opDate = moment(item.opDate);
                }
                if(item.insDate){
                    item.insDate = moment(item.insDate);
                }
                if(item.createdOn){
                    item.createdOn = moment(item.createdOn);
                }
            });
            return data;
        }
    }
})(angular.module('app.core'));



/*****************
 ** WEBPACK FOOTER
 ** ./app/core/base.factory.js
 ** module id = 155
 ** module chunks = 0
 **/